import DashboardService from "@/src/api/DashboardService.js";
import CRMService from "@/src/api/CRMService.js";
import { message } from "ant-design-vue";
import { transformCRMSearchResult } from "@/src/utils/crmFilterUtils.js";

export const fetchCompanyOptions = async (params = {}) => {
  const {
    searchTerm = "",
    limit = 100,
  } = params;

  try {
    const response = await CRMService.searchAllFields({
      object_type: 'companies',
      search_query: searchTerm,
      page: 1,
      page_size: limit,
    });

    if (response?.success && response?.results) {
      return response.results.map((company) => {
        const companyData = transformCRMSearchResult(company);
        return {
          value: companyData.id,
          label: companyData.name,
          data: companyData,
        };
      });
    } else {
      console.warn(
        "Failed to fetch companies:",
        response?.message || "Unknown error",
      );
      return [];
    }
  } catch (error) {
    console.error("Error fetching companies:", error);
    return [];
  }
};

export const fetchAllCompanies = async (limit = 100) => {
  return fetchCompanyOptions({ limit });
};

export const searchCompanies = async (searchTerm, options = {}) => {
  return fetchCompanyOptions({ searchTerm, ...options });
};

export const addCompanyOption = async (companyData) => {
  try {
    const response = await DashboardService.addCompany(companyData);

    if (response?.success && response?.company) {
      message.success("Company added successfully");
      return {
        value: response.company.id,
        label: response.company.name,
        data: response.company,
      };
    } else {
      message.error(
        "Failed to add company: " + (response?.errors || "Unknown error"),
      );
      return null;
    }
  } catch (error) {
    console.error("Error adding company:", error);

    return null;
  }
};

export const getCompanyOptionsForField = async (fieldName, context = {}) => {
  switch (fieldName.toLowerCase()) {
    case "company":
    case "current_company":
    case "companies":
      return fetchAllCompanies();

    default:
      return fetchAllCompanies();
  }
};

export const formatCompanyDisplay = (company) => {
  if (!company) return "";

  let display = company.name || "";
  if (company.website) {
    display += ` (${company.website})`;
  }
  return display;
};
